import { PaginationData } from "./pagination-data";
import { OrderingData } from "./ordering-data";

export class GetAllRequest {
    data : {paginationData : PaginationData,orderingData : OrderingData }
}
